import React, { ReactElement } from 'react';
import cx from 'classnames';

import { Popup } from 'components/UI/Popup';

import css from './imagedPopup.module.sass';

interface IProps {
  image: string | ReactElement;
  icon?: ReactElement;
  popupClassName?: string;
  bodyClassName?: string;
  iconHolderClassName?: string;
  isIndented?: boolean;
  zIndex?: number;
  onClose?: () => void;
}

export const ImagedPopup: React.FC<IProps> = ({
  image,
  icon,
  popupClassName,
  bodyClassName,
  iconHolderClassName,
  zIndex,
  isIndented = true,
  onClose,
  children,
}) => {
  return (
    <Popup
      onClose={onClose}
      popupClassName={popupClassName}
      bodyClassName={bodyClassName}
      zIndex={zIndex}
      isIndented={false}
    >
      {typeof image === 'string' ? (
        <img src={image} className={css.image} alt="thumbnail" />
      ) : (
        image
      )}
      <div
        className={cx(css.content, {
          [css.contentTypeIndented]: isIndented,
        })}
      >
        {icon && (
          <span className={cx(css.iconHolder, iconHolderClassName)}>
            {React.cloneElement(icon, {
              ...icon.props,
              className: cx(css.icon, icon.props.className),
            })}
          </span>
        )}
        {children}
      </div>
    </Popup>
  );
};
